<template lang="pug">
.filters-container.list
  .search
    sh-date-range-select(:value="dateRange" :init-date="init" :final-date="final" @change="onDateRangeChange")

  .search
    .input-container.input-search
      input.input(v-model="search" @keyup.enter="getPage" autocomplete="ño")
      label.label(:class="{ show: search }") Buscar
    .input-container.input-search-field.arrow
      select.select(v-model="searchBy" id="SearchField")
        option(v-for="(searchByField, index) in searchByFields" :value="searchByField") {{ capitalize(spanish(searchByField)) }}
      label.label(:class="{ show: searchBy }") Por

  .search
    .input-container.input-search
      input.input(v-model="search1" @keyup.enter="getPage" autocomplete="ño")
      label.label(:class="{ show: search1 }") Buscar
      .search-container.pointer(@click="getPage")
        span.material-symbols-outlined search
    .input-container.input-search-field.arrow
      select.select(v-model="searchBy1" id="SearchField")
        option(v-for="(searchByField, index) in searchByFields" :value="searchByField") {{ capitalize(spanish(searchByField)) }}
      label.label(:class="{ show: searchBy1 }") Por

  .filter
    .input-container.input-filter.arrow
      select.select(v-model="limit")
        option(v-for="limit in limits" :value="limit") {{ limit }}
      label.label(:class="{ show: limit }") Resultados
    .input-container.input-filter.arrow
      select.select(v-model="sort")
        option(v-for="sortByField in sortByFields" :value="sortByField") {{ capitalize(spanish(sortByField)) }}
      label.label(:class="{ show: sort }") Ordernar
    .order-direction.pointer(@click="toggleSortOrder" role="button" tabindex="0" @keyup.enter="toggleSortOrder" @keyup.space.prevent="toggleSortOrder")
      span.material-symbols-outlined {{ order === '-' ? 'arrow_downward' : 'arrow_upward' }}
</template>

<script>
import mFilters from '@/mixins/filters'
import { filtersToQueryParams, areQueryParamsDifferent } from '@/utils/urlFilters'
import shDateRangeSelect from '@/components/helpers/DateRangeSelect'

export default {
  name: 'Filters',

  components: { shDateRangeSelect },

  mixins: [mFilters],

  props: {
    resolver: String
  },

  data () {
    return {
      updatingFromUrl: false
    }
  },

  methods: {
    getPage () {
      this.$emit('getPage')
    },
    toggleSortOrder () {
      this.order = this.order === '-' ? '' : '-'
    },
    onDateRangeChange ({ init, final, selected }) {
      this.init = init
      this.final = final
      this.dateRange = selected
    },
    setConfigPage (key, value) {
      this.$store.commit('setConfigPage', { resolver: this.resolver, key, value })
      this.updateUrlFromFilters()
    },
    setConfigPageChange (key, value) {
      this.$store.commit('setConfigPage', { resolver: 'changes', key, value })
    },
    updateUrlFromFilters () {
      // Evitar bucles infinitos
      if (this.updatingFromUrl) return

      // Obtener filtros actuales del store
      const currentFilters = this.$store.state.filters[this.resolver]

      // Convertir a query params
      const newQueryParams = filtersToQueryParams(currentFilters)

      // Solo actualizar si hay cambios
      if (areQueryParamsDifferent(newQueryParams, this.$route.query)) {
        this.$router.replace({ query: newQueryParams }).catch(() => {})
      }
    },
    spanish (value) {
      const values = {
        order: 'orden',
        dni: 'cédula',
        name: 'nombre',
        phone: 'teléfono',
        phones: 'teléfono',
        type: 'tipo',
        value: 'valor',
        email: 'email',
        bannedBy: 'baneado por',
        status: 'estado',
        location: 'ciudad - municipio',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
        packReceived: 'Paquete recibido'
      }

      return values[value] || value
    },
    saveLimitInLocalStorage (collection, limit) {
      localStorage.setItem(`limit-${collection}`, limit)
    }
  },

  computed: {
    sortByFields () {
      return this.$store.state.list[this.resolver].sortByFields
    },
    searchByFields () {
      return this.$store.state.list[this.resolver].searchBy
    },
    limits () {
      return this.$store.state.list.limits
    },
    init: {
      get () {
        return this.$store.state.filters[this.resolver].init
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'init', value })
        if (this.resolver === 'orders') this.setConfigPageChange('init', value)
        this.updateUrlFromFilters()
      }
    },
    final: {
      get () {
        return this.$store.state.filters[this.resolver].final
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'final', value })
        if (this.resolver === 'orders') this.setConfigPageChange('final', value)
        this.updateUrlFromFilters()
      }
    },
    limit: {
      get () {
        return this.$store.state.filters[this.resolver].limit
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'limit', value })
        this.saveLimitInLocalStorage(this.resolver, value)
        if (this.resolver === 'orders') {
          this.setConfigPageChange('limit', value)
          this.saveLimitInLocalStorage('changes', value)
        }
        this.updateUrlFromFilters()
      }
    },
    order: {
      get () {
        return this.$store.state.filters[this.resolver].order
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'order', value })
        if (this.resolver === 'orders') this.setConfigPageChange('order', value)
        this.updateUrlFromFilters()
      }
    },
    search: {
      get () {
        return this.$store.state.filters[this.resolver].search
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'search', value })
        if (this.resolver === 'orders') this.setConfigPageChange('search', value)
        this.updateUrlFromFilters()
      }
    },
    searchBy: {
      get () {
        return this.$store.state.filters[this.resolver].searchBy
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'searchBy', value })
        if (this.resolver === 'orders') this.setConfigPageChange('searchBy', value)
        this.updateUrlFromFilters()
      }
    },
    search1: {
      get () {
        return this.$store.state.filters[this.resolver].search1
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'search1', value })
        if (this.resolver === 'orders') this.setConfigPageChange('search1', value)
        this.updateUrlFromFilters()
      }
    },
    searchBy1: {
      get () {
        return this.$store.state.filters[this.resolver].searchBy1
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'searchBy1', value })
        if (this.resolver === 'orders') this.setConfigPageChange('searchBy1', value)
        this.updateUrlFromFilters()
      }
    },
    sort: {
      get () {
        return this.$store.state.filters[this.resolver].sort
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'sort', value })
        if (this.resolver === 'orders') this.setConfigPageChange('sort', value)
        this.updateUrlFromFilters()
      }
    },
    dateRange: {
      get () {
        return this.$store.state.filters[this.resolver].dateRange
      },
      set (value) {
        this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'dateRange', value })
        if (this.resolver === 'orders') this.setConfigPageChange('dateRange', value)
        this.updateUrlFromFilters()
      }
    }
  }
}
</script>

<style lang="stylus">
.filters-container
  position relative

.filter, .search
  display flex
  justify-content space-between
  align-items flex-end
  border-radius 1em
  gap 1em
  margin 2rem 0

.search .input-container, .filter .input-container
  margin 0

.filter .select, .search .select, .search .input
  width 100%
  font-size 1.1em

.search-container
  position absolute
  top 1.2rem
  right 0rem
  transform scale(.8)
  z-index 11

  .material-symbols-outlined
    font-size 2.5rem
    color rgba(0, 0, 0, .8)

.sort-container
  padding-bottom 2.3em

.input-search
  position relative

.input-search .input
  padding-right 2.5em

.input-search-field
  flex-basis 48%
  padding-right 0

.order-direction
  flex-shrink 0
  display flex
  align-items center
  align-self flex-end

  .material-symbols-outlined
    font-size 2rem
    color rgba(0, 0, 0, .8)
    margin-bottom 0.5rem
</style>



// WEBPACK FOOTER //
// src/components/helpers/Filters.vue